module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="form-horizontal top-margined">\r\n    ';
 if (_.isEmpty(id)) { 
__p+='\r\n    <h4>Add comment</h4>\r\n    ';
 } else { 
__p+='\r\n    <h4>Edit comment</h4>\r\n    ';
 } 
__p+='\r\n    <div>\r\n        <div class="form-group">\r\n            <label class="checkbox" style="margin-left: 25px;"><input type="checkbox" id="is-internal" ';
 if (internal) { 
__p+=' checked ';
 } 
__p+=' >Is Internal?</label>\r\n        </div>\r\n        <div class="form-group">\r\n            <textarea class="form-control" rows="5" id="text">'+
((__t=( text ))==null?'':__t)+
'</textarea>\r\n        </div>\r\n        <div class="left-buttons">\r\n            <button type="button" class="btn btn-success" id="send" disabled>\r\n                ';
 if (_.isEmpty(id)) { 
__p+='\r\n                Send\r\n                ';
 } else { 
__p+='\r\n                Update\r\n                ';
 } 
__p+='\r\n            </button>\r\n            <button type="button" class="btn btn-success" id="cancel">Cancel</button>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div id="yes-no-confirmation-modal"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/comments/comment-form.html
// module id = 267
// module chunks = 0